import React from 'react';
import { FaUsers, FaRulerCombined, FaTools, FaDollarSign, FaShieldAlt, FaClock } from 'react-icons/fa';

const WhyChoose = () => {
  return (
    <div className="bg-white py-16 px-6 md:px-12 lg:px-20">
      {/* Heading Section */}
      <div className="text-center mb-16">
        <h2 className="text-4xl font-bold text-[#003EA1] uppercase tracking-wide">
          Why Choose <span className="text-[#0274BD]">Value Blinds?</span>
        </h2>
        <p className="text-lg text-gray-600 mt-3">
          Experience the perfect combination of<strong> affordability, quality, and expert service.</strong>
        </p>
      </div>

      {/* Features Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
        {/* Affordable Pricing */}
        <div className="group flex flex-col items-center text-center p-8 bg-gray-100 rounded-3xl shadow-md hover:shadow-lg transition-all duration-300">
          <div className="w-20 h-20 flex items-center justify-center bg-[#0274BD] text-white rounded-full text-3xl shadow-md transform group-hover:scale-110 transition-all">
            <FaDollarSign />
          </div>
          <h4 className="text-2xl font-semibold mt-5 mb-3 text-gray-800">Affordable Pricing</h4>
          <p className="text-gray-600">Get high-quality blinds at unbeatable prices.</p>
        </div>

        {/* Expert Guidance */}
        <div className="group flex flex-col items-center text-center p-8 bg-gray-100 rounded-3xl shadow-md hover:shadow-lg transition-all duration-300">
          <div className="w-20 h-20 flex items-center justify-center bg-[#0274BD] text-white rounded-full text-3xl shadow-md transform group-hover:scale-110 transition-all">
            <FaUsers />
          </div>
          <h4 className="text-2xl font-semibold mt-5 mb-3 text-gray-800">Expert Guidance</h4>
          <p className="text-gray-600">Get free expert consultation to find the best blinds for your space.</p>
        </div>

        {/* Precise Measurements */}
        <div className="group flex flex-col items-center text-center p-8 bg-gray-100 rounded-3xl shadow-md hover:shadow-lg transition-all duration-300">
          <div className="w-20 h-20 flex items-center justify-center bg-[#0274BD] text-white rounded-full text-3xl shadow-md transform group-hover:scale-110 transition-all">
            <FaRulerCombined />
          </div>
          <h4 className="text-2xl font-semibold mt-5 mb-3 text-gray-800">Precise Measurements</h4>
          <p className="text-gray-600">We ensure perfect fit with professional measuring services.</p>
        </div>

        {/* Professional Installation */}
        <div className="group flex flex-col items-center text-center p-8 bg-gray-100 rounded-3xl shadow-md hover:shadow-lg transition-all duration-300">
          <div className="w-20 h-20 flex items-center justify-center bg-[#0274BD] text-white rounded-full text-3xl shadow-md transform group-hover:scale-110 transition-all">
            <FaTools />
          </div>
          <h4 className="text-2xl font-semibold mt-5 mb-3 text-gray-800">Professional Installation</h4>
          <p className="text-gray-600">Our team handles installation seamlessly for a hassle-free experience.</p>
        </div>

        {/* Quality & Durability */}
        <div className="group flex flex-col items-center text-center p-8 bg-gray-100 rounded-3xl shadow-md hover:shadow-lg transition-all duration-300">
          <div className="w-20 h-20 flex items-center justify-center bg-[#0274BD] text-white rounded-full text-3xl shadow-md transform group-hover:scale-110 transition-all">
            <FaShieldAlt />
          </div>
          <h4 className="text-2xl font-semibold mt-5 mb-3 text-gray-800">Quality & Durability</h4>
          <p className="text-gray-600">Our blinds are built to last with premium materials.</p>
        </div>

        {/* Fast Delivery */}
        <div className="group flex flex-col items-center text-center p-8 bg-gray-100 rounded-3xl shadow-md hover:shadow-lg transition-all duration-300">
          <div className="w-20 h-20 flex items-center justify-center bg-[#0274BD] text-white rounded-full text-3xl shadow-md transform group-hover:scale-110 transition-all">
            <FaClock />
          </div>
          <h4 className="text-2xl font-semibold mt-5 mb-3 text-gray-800">Fast Delivery</h4>
          <p className="text-gray-600">We ensure quick and reliable delivery to your doorstep.</p>
        </div>
      </div>
    </div>
  );
};

export default WhyChoose;
